<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">Change Post Status</v-card-title>
      <v-card-text class="body-2">
        <v-row>
          <v-col xs="6">
            <v-text-field
              label="Current Status"
              filled
              disabled
              :value="displayStatus(post ? post.status : null)"
            ></v-text-field>
          </v-col>
          <v-icon>mdi-arrow-right-thick</v-icon>
          <v-col xs="6">
            <v-select
              v-model="selectedStatus"
              :items="status_options"
              item-text="display"
              item-value="status"
              :menu-props="{ maxHeight: '400' }"
              label="New Status"
              filled
              hint="Select new Post Status"
              persistent-hint
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" id="close" text @click.native="$emit('input')">Close</v-btn>
        <v-btn
          color="green"
          text
          @click="changeStatus()"
          :disabled="disableSubmit"
        >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import postAPIs from './postApi';
import config from '@/config';
export default {
  props: {
    value: Boolean,
    post: Object,
    postIds: Array
  },
  data() {
    return {
      postData: null,
      options: [0, 1, 2, 3, 4, 5],
      selectedStatus: null
    };
  },
  methods: {
    changeStatus() {
      if (this.selectedStatus === null) {
        this.$swal({
          title: 'Error',
          type: 'error',
          text: 'Empty Status'
        });
      } else {
        if (this.postIds.length > 0) {
          // if bulk change
          this.changeBulkPostStatus()
          return;
        }
        postAPIs
          .changeStatus(this.postData._id, this.selectedStatus)
          .then(response => {
            if (response.success) {
              this.$emit('updated', true);
              this.$emit('input');
              this.$swal({
                title: 'Success',
                text: 'Post Status Changed. Do you want to go to updated stage?',
                type: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No, Stay here'
              }).then(result => {
                if (result.value) {
                  this.$router.push({ name: this.displayStatus(this.selectedStatus) }); // because router name is same with campaign display name
                }
              });
            } else {
              this.$swal('Post Status Changed Failed');
            }
          })
          .catch(err => console.error(err));
      }
    },
    changeBulkPostStatus() {
      postAPIs
        .changeBulkStatus(this.postIds, this.selectedStatus)
        .then(response => {
          if (response.success) {
            this.$emit('updated', true);
            this.$emit('input');
            this.$swal({
              title: 'Success',
              text: 'Post Status Changed. Do you want to go to updated stage?',
              type: 'success',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No, Stay here'
            }).then(result => {
              if (result.value) {
                this.$router.push({ name: this.displayStatus(this.selectedStatus) }); // because router name is same with campaign display name
              }
            });
          } else {
            this.$swal('Post Status Changed Failed');
          }
        })
        .catch(err => console.error(err));
    },
    displayStatus(status) {
      if (status === null || status === undefined) {
        return;
      }
      return config.postStatusDisplayExternal[status]['display'];
    }
  },
  computed: {
    status_options: function() {
      let data = [];
      Object.entries(config.postStatus).forEach(item => {
        // Rate_Card and Pairing_Brief Status are disabled for now
        data.push({
          status: item[1],
          display: config.postStatusDisplayExternal[item[1]]['display']
        });
      });
      return data;
    },
    disableSubmit() {
      return (!this.post && (this.postIds && this.postIds.length === 0)) || (this.post && this.selectedStatus === this.post.status)
    }
  },
  watch: {
    post(newPost) {
      if (newPost !== null) {
        this.postData = newPost;
        this.selectedStatus = newPost.status;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// ChangePostStatusModal.vue?6a41fcc6